import firebase from 'firebase';
import 'firebase/firestore';

const localState = {
  teams: {},
  players: {},
};

const mutations = {
  SET_PLAYERS(state, players) {
    state.players = players;
  },

  SET_TEAMS(state, teams) {
    state.teams = teams;
  },
};

const getters = {
  teamByAbbreviation: ({ teams }) => (abbr) => {
    let team = teams[-1];

    Object.keys(teams).forEach((id) => {
      if (teams[id].abbreviation === abbr) {
        team = teams[id];
      }
    });

    return team;
  },
};

const actions = {
  LOAD_PLAYERS({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (Object.keys(state.players).length) {
        resolve();
      } else {
        firebase.firestore().collection('lists').doc('players')
          .get()
          .then((playersDoc) => {
            if (playersDoc.exists) {
              commit('SET_PLAYERS', playersDoc.data());
              resolve();
            } else {
              reject();
            }
          })
          .catch(reject);
      }
    });
  },

  LOAD_TEAMS({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (Object.keys(state.teams).length) {
        resolve();
      } else {
        firebase.firestore().collection('lists').doc('teams')
          .get()
          .then((teamsDoc) => {
            if (teamsDoc.exists) {
              commit('SET_TEAMS', teamsDoc.data());
              resolve();
            } else {
              reject();
            }
          })
          .catch(reject);
      }
    });
  },
};

export default {
  namespaced: true,
  state: localState,
  mutations,
  getters,
  actions,
};
